exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".TabsContentContainer__tabs-content___YoFia{flex:1;display:flex;flex-direction:row;width:100%;transition:transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);overflow:hidden}\n", ""]);

// Exports
exports.locals = {
	"button-width-size": "32",
	"no-scroll-padding": "12",
	"tabs-content": "TabsContentContainer__tabs-content___YoFia"
};